import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
  filter,
  includes,
  map,
  uniq,
  intersection,
  merge,
  keyBy,
  mapValues,
  find,
} from 'lodash';
import {
  Button,
  Grid,
  Row,
  Col,
  Alert,
} from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import {css} from 'aphrodite';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/fontawesome-pro-solid';

import {
  getStatePayerCoverageList,
  getStateCoverageProfiles,
  setStateCoverageShowAlert,
  ERROR_ALERT,
  NO_ROW_ALERT,
} from 'actions/coverage';

import {
  getError,
  getInProgress,
  getLastRefreshedDate,
  getShowErrorAlert,
  getShowNoRowsAlert,
} from 'selectors/coverage';

import {
  filterForMapStates,
  orderData,
  renderMultifieldString,
  validateObjectProperties,
} from 'libs/salmon-utils';

import {getSettings} from 'selectors/settings';

import {getErrorField, hasClass} from 'libs/react-widgets';
import TabularDataBasic from 'components/TabularDataBasic';
import USMap, {USStates} from 'components/USMap';
import {ToolTipCell} from 'components/ToolTipCell';
import MultiSelect from 'components/MultiSelect';
import Isi from 'components/Isi';
import ErrorAlert from 'components/ErrorAlert';
import StateCoverageProfileDocumentDownload from 'components/StateCoverageProfileDocumentDownload';
import {
  ExitModal,
  FeatureModal,
  CoverageSummaryModal,
  DisclaimerModal,
  ContactInstructionsModal,
} from '../Modals';
import Loader from 'components/Loader';
import './styles.scss';
import {sortProducts, triStateDisplay, getCoverageColumns} from './table-formatter';

const queryString = require('query-string');

export class Coverage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPayers: [], // multi-select values
      selectedStates: [],
      selectedIndications: [],
      selectedPlanTypes: [],
      selectedProducts: [],
      selectedPbms: [],
      previousSelectedProducts: null,
      filteredPayers: [], // locked-in values after hitting search
      filteredStates: [],
      filteredIndications: [],
      filteredPlanTypes: [],
      filteredProducts: [], // single select with first element of the array
      filteredPbms: [],
      results: false,
      coverageSummary: {},
      showExitModal: false,
      showSummaryModal: false,
      showContactInstructionsModal: false,
      showDisclaimerModal: false,
      showFeatureModal: this.props.coveragePositions.length === 0 ? !props.settings.newFeatureModal.disabled : false,
      showInstruction: true,
      urlParameters: queryString.parse(
        window.location.search,
        {
          arrayFormat: 'bracket',
          parseBooleans: true,
        }
      ),
    };

    this.handleChange = this.handleChange.bind(this);
    this._handleHide = this._handleHide.bind(this);
    this._handleDocumentClick = this._handleDocumentClick.bind(this);
    this._handleSummaryClick = this._handleSummaryClick.bind(this);
    this._handleContactInstructionsClick = this._handleContactInstructionsClick.bind(this);
    this._handleOpenDocument = this._handleOpenDocument.bind(this);
    this._handleOpenMedicalCoverage = this._handleOpenMedicalCoverage.bind(this);
    this._filterCoverage = this._filterCoverage.bind(this);
    this._handleUSMapClick  = this._handleUSMapClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    let filtersChanged = false;

    // Check if props have changed by looking at filters
    for (let filter of this.props.settings.filterLayout) {
      const filterProp = (filter.filter === 'state') ? 'usStates' : `${filter.filter}s`;
      if (JSON.stringify(this.props[filterProp]) !== JSON.stringify(prevProps[filterProp])) {
        filtersChanged = true;
        break;
      }
    }

    // Check if url parameters exist and are different from internal state
    if (
      filtersChanged &&
      Object.keys(this.state.urlParameters).length
    ) {
      let filterState = {};
      let mergedState = {};

      // Loop through each filter and update the state
      for (let filter of this.props.settings.filterLayout) {
        filterState = merge(filterState, this._updateFiltersFromUrl(filter.filter));

        // add the filter to the merged state
        mergedState = {
          ...mergedState,
          ...filterState,
          results: mergedState.results !== undefined ? filterState.results && mergedState.results : filterState.results,

        };
      }

      this.setState(mergedState);
    }
  }

  componentDidMount() {
    const {
      dispatchGetStatePayerCoverageList,
      dispatchGetStateCoverageProfiles,
      settings,
    } = this.props;

    // don't fetch again if component remounts
    if (this.props.coveragePositions.length === 0) {
      if (settings.domain) {
        dispatchGetStatePayerCoverageList(settings.domain, settings.content.searchErrorUnavailable);
        if (settings.stateCoverageProfiles && settings.stateCoverageProfiles.enabled) {
          dispatchGetStateCoverageProfiles(settings.domain);
        }
      } else if (settings.drugId) {
        dispatchGetStatePayerCoverageList(settings.drugId, settings.content.searchErrorUnavailable);
      }
    }
  }

  handleChange(selected, type) {
    // eslint-disable-next-line
    switch (type) {
      case 'payers': this.setState({selectedPayers: selected});
        break;
      case 'usStates': this.setState({selectedStates: selected});
        break;
      case 'indications': this.setState({selectedIndications: selected});
        break;
      case 'planTypes': this.setState({selectedPlanTypes: selected});
        break;
      case 'products':
        //disallow multiple select
        this.setState({selectedProducts: selected.length > 1 ? selected.splice(1, 1) : selected});
        break;
      case 'pbms': this.setState({selectedPbms: selected});
      default:
        break;
    }
  }

  _handleMapStateClick(el) {
    const {
      selectedStates,
    } = this.state;

    const currentElement = el.currentTarget;
    const clickedState = find(this.props.usStates, {id: currentElement.id});

    let currentSelectedStates = [...selectedStates];
    if (hasClass(currentElement, 'active')) {
      currentSelectedStates = currentSelectedStates.filter(
        (state) => state.id !== currentElement.id
      );
    } else {
      currentSelectedStates = [...currentSelectedStates, clickedState];
    }

    this.setState({
      selectedStates: currentSelectedStates,
    });
  }

  _filterCoverage() {
    const {
      settings,
      planTypes,
    } = this.props;

    const {
      selectedStates,
      selectedPayers,
      selectedIndications,
      selectedPlanTypes,
      selectedProducts,
      selectedPbms,
    } = this.state;

    // Extract visible columns from settings
    const visibleColumns = settings.table.columns.map((column) => column.property);

    // Filter planTypes based on selectedPlanTypes and visible columns
    const filteredPlanTypes = selectedPlanTypes.reduce((acc, selectedPlanType) => {
      if (typeof(selectedPlanType.id) === 'number') {
        return acc.concat(planTypes.filter((planType) =>
          planType.id === selectedPlanType.id && visibleColumns.includes('planType')
        ));
      } else {
        let mappedPlanTypes = selectedPlanType.id.split(',');
        return acc.concat(planTypes.filter((planType) =>
          mappedPlanTypes.includes(planType.id.toString()) && visibleColumns.includes('planType')
        ));
      }
    }, []);

    // Update browser url parameters.
    const newUrlParameters = this._updateUrlParameters();
    const newUrl = queryString.stringify(newUrlParameters, {arrayFormat: 'bracket'});
    window.history.pushState(newUrl, '', `/?${newUrl}`);

    this.setState({
      results: true,
      showInstruction: settings.content.alwaysShowInstruction,
      filteredPayers: visibleColumns.includes('payer') ? selectedPayers : [],
      filteredStates: visibleColumns.includes('states') ? selectedStates : [],
      filteredIndications: visibleColumns.includes('indications') ? selectedIndications : [],
      filteredPbms: visibleColumns.includes('pbm') ? selectedPbms : [],
      urlParameters: newUrlParameters,
      filteredPlanTypes,
      filteredProducts: selectedProducts,
    }, () => {
      this._setAlert(NO_ROW_ALERT, true);
      if (this.props.settings.jumpToResultsAfterSearching) {
        document.getElementById('results').scrollIntoView();
      }
    });
  }

  /**
    * Returns an object containing the new URL parameters.
    *
    * @returns {array}
   */
  _updateUrlParameters() {
    let newUrlParameters = this.state.urlParameters || {};

    for (let filter of this.props.settings.filterLayout) {

      const selectedFilterString = (filter.filter === 'plan') ? 'selectedPlanTypes' : `selected${filter.filter.charAt(0).toUpperCase() + filter.filter.slice(1)}s`;

      const selectedFilter = this.state[selectedFilterString];

      const urlAlias = (this.props.settings.urlParametersMap[filter.filter] && this.props.settings.urlParametersMap[filter.filter].alias) ? this.props.settings.urlParametersMap[filter.filter].alias : filter.filter;

      newUrlParameters[urlAlias] = uniq(
        selectedFilter.map((x) => {
          return x.id;
        })
      );
    }

    return newUrlParameters;
  }

  /**
   * Returns valid items and a formatted filter string based on the provided filter and parameters.
   *
   * @param {Array} parameters - The list of IDs to validate.
   * @param {string} filter - The filter type (e.g., 'state', 'plan').
   * @param {Object} props - The props object containing data arrays (e.g., 'usStates', 'planTypes').
   * @returns {Object} An object containing:
   *   - {Array} validItems: Filtered, non-duplicated items.
   *   - {string} filterString: Capitalized filter name (e.g., 'PlanType', 'State').
   */
  _getValidItems(parameters, filter, props) {
    const filterPropString = (filter === 'state')
      ? 'usStates'
      : (filter === 'plan')
        ? 'planTypes'
        : `${filter}s`;

    // Map over the parameters to find matching items in the props
    const mappedItems = parameters.map((x) => {
      return props[filterPropString].find((y) => y.id == x);
    }).filter(Boolean); // Remove any falsy values

    // Map over the parameters to find matching items in the props and filter out invalid ones
    const validItems = Array.from(new Set(mappedItems));

    // Determine the filter string to use for the output
    const filterString = (filter === 'plan')
      ? 'PlanType'
      : filter.charAt(0).toUpperCase() + filter.slice(1);

    return {validItems, filterString};
  }

  /**
   *
   * Given a filter, return the updated selected and filtered states, and whether there are results.
   *
   * @param filter
   * @returns {
   *     results: boolean,
   *     filteredFilter: Array,
   *     selectedFilter: Array
   * }
   */
  _updateFiltersFromUrl(filter) {
    const filterAlias = this.props.settings.urlParametersMap[filter]?.alias || filter
    const parameters = this.state.urlParameters ? this.state.urlParameters[filterAlias] : null;

    // if no parameters check if the filter is required
    if (!parameters) {
      if (this.props.settings.urlParametersMap[filter] && this.props.settings.urlParametersMap[filter].required) {
        return {
          results: false,
        };
      } else {
        // otherwise we still want results even if there are no parameters
        return {
          results: true,
        }
      }
    }

    const {validItems, filterString} = this._getValidItems(parameters, filter, this.props);

    return {
      results: Boolean(validItems.length),
      [`filtered${filterString}s`]: validItems,
      [`selected${filterString}s`]: validItems,
    };
  }

  _setAlert(type, value) {
    this.props.dispatchSetStateCoverageShowAlert({
      type,
      value,
    });
  }

  // Adds text property to the fields and populate it from rowData.
  _addTextToFields(fields, rowData) {
    return fields.map((el) => {
      let data = rowData[el.property];
      if (Array.isArray(data)) {
        el.text = data.length > 0 ? data.sort().join(', ') : el.default;
      } else {
        el.text = data ? data : el.default;
      }
      return el;
    });
  }

  _handleUSMapClick(el) {
    const {
      selectedStates,
    } = this.state;

    const currentElement = el.currentTarget;
    let include = !hasClass(currentElement, 'active');

    let currentSelectedStates = filterForMapStates(selectedStates, currentElement.id, include, USStates);

    this.setState({
      selectedStates: currentSelectedStates,
    });
  }

  _handleHide() {
    this.setState({
      showExitModal: false,
      showSummaryModal: false,
      showFeatureModal: false,
      showDisclaimerModal: false,
      showContactInstructionsModal: false,
    });
  }

  _handleDocumentClick(e) {
    e.preventDefault();

    this.setState({
      showExitModal: true,
      documentLink: e.currentTarget.href,
    });
  }

  _handleSummaryClick(e) {
    e.preventDefault();

    this.setState({
      showSummaryModal: true,
      coverageSummaryClickedId: e.currentTarget.id,
    });
  }

  _handleContactInstructionsClick(e) {
    e.preventDefault();
    this.setState({
      showContactInstructionsModal: true,
      contactInstructionsClickedId: e.currentTarget.id,
    });
  }

  _handleOpenDocument() {
    window.open(this.state.documentLink, '_blank', 'noopener,noreferrer');

    this.setState({
      showExitModal: false,
    });
  }

  _handleOpenMedicalCoverage(settings, rowData, storageID) {
    const lastRefreshedDate = this.props.lastRefreshedDate;
    let disclaimer = settings.content.medicalNecessity.disclaimer;
    if (lastRefreshedDate) {
      disclaimer = disclaimer.replace(/\[\[(.*)\]\]/, lastRefreshedDate);
    }

    // Expire the data in 1 hour.
    const expiry = new Date().getTime() + 3600000;

    const coverageData = {
      fillInTheBlanks: settings.content.medicalNecessity.fillInTheBlanks,
      title: renderMultifieldString(settings.content.medicalNecessity.title, rowData, settings.content.medicalNecessity.allStates),
      fields: this._addTextToFields(settings.content.medicalNecessity.fields, rowData),
      disclaimer: disclaimer,
      medicalNecessityStyles: settings.styles.medicalNecessityChecklist,
      header: {
        logo: settings.header.productLogo,
        style: settings.styles.headerLogo,
      },
      expiry: expiry,
    };

    const sID = storageID ? storageID : Math.floor(Math.random() * 1000000);
    localStorage.setItem(`medicalNecessityChecklist-${sID}`, JSON.stringify(coverageData));
    window.open(`medicalNecessityChecklist?id=${sID}`, '_blank', 'noopener,noreferrer');

    return sID;
  }

  render() {
    const {
      selectedStates,
      selectedPayers,
      selectedIndications,
      selectedPlanTypes,
      selectedProducts,
      selectedPbms,
      filteredStates,
      filteredPayers,
      filteredIndications,
      filteredPlanTypes,
      filteredProducts,
      filteredPbms,
      results,
      coverageSummaryClickedId,
      contactInstructionsClickedId,
      showExitModal,
      showSummaryModal,
      showContactInstructionsModal,
      showFeatureModal,
      showDisclaimerModal,
      showInstruction,
    } = this.state;

    const {
      inProgress,
      usStates,
      planTypes,
      payers,
      indications,
      products,
      pbms,
      coveragePositions,
      stateCoverageProfiles,
      settings,
      styleSheet,
      error,
      lastRefreshedDate,
      showErrorAlert,
      showNoRowsAlert,
    } = this.props;

    let coverageSummaryHashMap = {};
    let contactInstructionsHashMap = {};
    let tableRows = [];

    if (results && this.props.usStates.length) {
      const indicationsHashMap = indications.reduce((acc, indication) => {
        let id = indication.id;
        acc[id] = indication.label;
        return acc;
      }, {});

      // Reducer callback for recursively reducing filteredPlanTypes into set of all matching plantypes,
      // including all descendants
      const recurseChildrenPlanType = (acc, planType) => {
        let childrenPlanTypes = map(filter(planTypes, ['parentname', planType]), 'label');
        return acc.concat(childrenPlanTypes.reduce(recurseChildrenPlanType, childrenPlanTypes));
      };
      const matchingPlanTypes = map(filteredPlanTypes, 'label').reduce(recurseChildrenPlanType, map(filteredPlanTypes, 'label'));

      //TODO: Refactor filter of coverage position data by not using filteredXXXX (like filteredPayers)
      let filteredPositions = coveragePositions.reduce((acc, val) => {
        if ((filteredPayers.length === 0) || includes(map(filteredPayers, 'id'), val.payerid)) {
          if ((filteredIndications.length === 0) || (intersection(map(filteredIndications, 'id'), val.indicationIds).length !== 0)) {
            let filteredNodes = filter(val.presenceNodes, (node) => {
              // Filter presenceNodes by states. No filter corresponding to the filter array being empty
              let stateExist = (filteredStates.length === 0) ? true : includes(map(filteredStates, 'id'), node.stateAbbr);
              // Filter presenceNodes by plantypes, including node if plantype (not originalPlanType)
              // matches one of the pre-generated matching plantypes array
              let planExist = (filteredPlanTypes.length === 0) ? true : includes(matchingPlanTypes, node.planType);

              return planExist && stateExist;
            });

            // Filter for indications and use indication label in column data
            if (filteredIndications.length !== 0) {
              val.indications = filteredIndications.reduce((acc, indicationId) => {
                if (includes(val.indicationIds, indicationId.id)) {
                  acc.push(indicationId.label);
                }

                return acc;
              }, []);
            } else {
              val.indications = val.indicationIds.map((id) => indicationsHashMap[id]);
            }

            acc.push({
              ...val,
              presenceNodes: filteredNodes,
            });
          }
        }

        return acc;
      }, []);

      if (filteredProducts.length !== 0) {
        filteredPositions = filteredPositions.filter( (position) => {
          return position.product.id === filteredProducts[0].id;
        });
      }

      // Filter for positions by pbm.
      if (filteredPbms.length !== 0) {
        const pbmIds = filteredPbms.map((x) => x.id);
        filteredPositions = filteredPositions.filter( (position) => {
          return pbmIds.includes(position?.pbmid);
        });
      }

      /* Check if we do rollup per #2281 or display plans that match the filteredPlanTypes per #7620 */
      // Default behaviour
      let dynamicRollupEnabled = false;
      if (settings.filterLayout && settings.filterLayout.length) {
        const filterLayout = settings.filterLayout;
        const planFilterSetting = filterLayout.find((filterSetting) => {
          return (filterSetting.filter === 'plan');
        });
        dynamicRollupEnabled = (planFilterSetting && planFilterSetting.dynamicRollup);
      }
      // get parent nodes from planTypes tree
      const parentPlanTypeNames = map(
        planTypes.filter((planType) => planType.parentname === null),
        (parentPlanType) => parentPlanType.label
      );
      // Check if selected filters are parent plan types
      // If even 1 filtered plan type is not a parent, return true
      const hasChildFilter = filteredPlanTypes.some((filteredPlanType) => {
        return (parentPlanTypeNames.indexOf(filteredPlanType.label) === -1);
      });

      filteredPositions.forEach((position) => {
        // Dynamically check if we do rollup per #2281 or display plans that match the filteredPlanTypes per #7620
        const planTypeMustMatchFilteredPlanTypes = dynamicRollupEnabled && hasChildFilter;
        let planTypes = [];

        // Get planTypes that match the actual plan type values the user filtered for.
        if (planTypeMustMatchFilteredPlanTypes) {
          let validPlanTypes = new Set(map(filteredPlanTypes, 'label'));

          let planTypeMatches = [];
          position.presenceNodes.forEach((val) => {
            if (validPlanTypes.has(val.planType)) {
              planTypeMatches.push(val.planType);
            }
            if (validPlanTypes.has(val.originalPlanType)) {
              planTypeMatches.push(val.originalPlanType);
            }
          });

          planTypes = uniq(planTypeMatches);
        } else {
          planTypes = uniq(map(position.presenceNodes, 'originalPlanType'));
        }

        planTypes.forEach((currentPlanType) => {
          let states = position.presenceNodes.reduce((acc, val) => {
            if ((val['originalPlanType'] === currentPlanType) ||
               (planTypeMustMatchFilteredPlanTypes && val['planType'] === currentPlanType)) {
              if (!includes(acc, val.stateAbbr)) {
                acc.push(val.stateAbbr);
              }
            }
            return acc;
          }, []);

          states.sort();

          let salmonDocumentsData = [];
          const showSalmonDocuments = settings.table.columns.filter((el) => el.property === 'salmonDocuments');
          if (showSalmonDocuments.length) {
            salmonDocumentsData = orderData(position.salmonDocuments, 'title', showSalmonDocuments[0].titleOrder)
          }

          // If you update this, you will likely also need to update
          // src/libs/salmon-utils.js:coveragePositionTemplate
          // for data consistency.
          let row = {
            id: `${position.coveragepositionid}-${position.payer}-${currentPlanType}`,
            benefitType: position.benefitType,
            contacts: position.contacts,
            contactModalData: {
              expeditedpa: position.expeditedpa,
              peertopeer: position.peertopeer,
              contactinstructions: position.contactinstructions,
            },
            covered: position.covered,
            coveredMedicalCodes: position.coveredMedicalCodes,
            criteria: position.criteria,
            criteriaMarkdown: position.criteriamarkdown,
            documentUrl: {
              policyUrl: position.policyUrl,
              priorAuthorizationUrl: position.priorAuthorizationUrl,
            },
            indications: position.indications,
            payer: position.payer,
            planType: currentPlanType,
            priorAuthorizationText: position.priorAuthorizationText,
            priorAuthorization: position.priorAuthorizationRequired,
            states,
            product: position.product === undefined ? null : position.product.name,
            verballyConfirmed: position.verballyConfirmed,
            lastReviewDate: position.lastReviewDate,
            salmonDocuments: salmonDocumentsData,
            stepEditText: position.stepEditText,
            pbm: position.pbm,
          };

          coverageSummaryHashMap[`${position.coveragepositionid}-${position.payer}-${currentPlanType}`] = {
            states,
            indications: position.indications,
            payer: position.payer,
            planType: currentPlanType,
            criteria: position.criteria,
            policyUrl: position.policyUrl,
            stepEdit: position.stepEdit,
            stepEditText: position.stepEditText,
            coveredMedicalCodes: position.coveredMedicalCodes,
            priorAuthorizationText: position.priorAuthorizationText,
            initialdiagnosis: position.initialdiagnosis,
            initialagerequirement: position.initialagerequirement,
            prescriberRequirementsText: position.prescriberRequirementsText,
            monitoringRequirement: position.monitoringRequirement,
            coverageSummaryFields: [
              {id: 'Diagnosis', initialTherapy: position.initialdiagnosis, continuedTherapy: position.continueddiagnosis},
              {id: 'Step Requirement', initialTherapy: (position.stepEditText ? position.stepEditText : position.stepEdit.join(', ')), continuedTherapy: null},
              {id: 'Quantity Limit', initialTherapy: triStateDisplay(position.initialquantitylimit), continuedTherapy: triStateDisplay(position.continuedquantitylimit)},
              {id: 'Age requirement', initialTherapy: (position.initialagerequirement ? position.initialagerequirement : 'Unspecified'), continuedTherapy: (position.continuedagerequirement ? position.continuedagerequirement : 'Unspecified')},
              {id: 'Prescriber Requirements', initialTherapy: triStateDisplay(position.initialprescriberrequirements), continuedTherapy: triStateDisplay(position.continuedprescriberrequirements)},
              {id: '(Re)Authorization Duration', initialTherapy: (position.initialreauthorizationduration ? position.initialreauthorizationduration : 'Unspecified'), continuedTherapy: (position.continuedreauthorizationduration ? position.continuedreauthorizationduration : 'Unspecified')},
            ],
            verballyConfirmed: position.verballyConfirmed,
          };

          contactInstructionsHashMap[`${position.coveragepositionid}-${position.payer}-${currentPlanType}`] = {
            ...mapValues(keyBy(position.contacts, 'type'), 'contact'), // Add all available phone numbers as attributes.
            expeditedpa: triStateDisplay(position.expeditedpa, null),
            peertopeer: triStateDisplay(position.peertopeer, null),
            contactinstructions: position.contactinstructions,
          };

          tableRows.push(row);
        });
      });
    }

    const tableColumns = getCoverageColumns({
      props: this.props,
      handleDocumentClick: this._handleDocumentClick,
      handleSummaryClick: this._handleSummaryClick,
      handleOpenMedicalCoverage: this._handleOpenMedicalCoverage,
      handleContactInstructionsClick: this._handleContactInstructionsClick,
      openDisclaimerModal: () => this.setState({showDisclaimerModal: true})
    });

    const tableDisclaimer = lastRefreshedDate ? settings.content.tableDisclaimerExpanded.markdown.replace(/\[\[(.*)\]\]/, lastRefreshedDate) : null;
    const tableFooter = (
      <tfoot id={'disclaimer'} data-testid="disclaimer-footer">
        <tr>
          <td colSpan={tableColumns.length} className={css(styleSheet.footNote)}>
            <ReactMarkdown escapeHtml={false} source={tableDisclaimer} />
          </td>
        </tr>
      </tfoot>
    );

    let filterInputs = [];
    let filterRowElements = [];
    settings.filterLayout.forEach((column) => {
      if (column.filter === 'state') {
        filterRowElements.push(
          <Col key="state" sm={column.gridWidth} className={`col-sm-offset-${column.offset}`}>
            <MultiSelect
              label={column.label}
              placeholder={column.placeholder}
              options={usStates}
              selected={selectedStates}
              isFetching={inProgress}
              handleChange={this.handleChange}
              selectHintOnEnter={false}
              type={'usStates'}/>
          </Col>
        );
      } else if (column.filter === 'payer') {
        filterRowElements.push(
          <Col key="payer" sm={column.gridWidth} className={`col-sm-offset-${column.offset}`}>
            <MultiSelect
              label={column.label}
              placeholder={column.placeholder}
              options={payers}
              selected={selectedPayers}
              isFetching={inProgress}
              handleChange={this.handleChange}
              selectHintOnEnter={false}
              type={'payers'}/>
          </Col>
        );
      } else if (column.filter === 'plan') {
        let displayedPlanTypes = settings.displayedPlanTypes.length ? settings.displayedPlanTypes.map((planType) => {
          return {id: planType.ids.join(','), ...planType};
        }) : planTypes;

        filterRowElements.push(
          <Col key="plan" sm={column.gridWidth} className={`col-sm-offset-${column.offset}`}>
            <MultiSelect
              label={
                (settings.content.planTypeHelpHover.length) ?
                  <span>{column.label}
                    <ToolTipCell
                      text={settings.content.planTypeHelpHover}
                      placeholder={(<FontAwesomeIcon icon={faInfoCircle}/>)}
                      placement={'bottom'}
                      styleSheet={styleSheet}
                      id={'plantype-tooltip'}
                    />
                  </span> :
                  column.label
              }
              placeholder={column.placeholder}
              options={displayedPlanTypes}
              selected={selectedPlanTypes}
              isFetching={inProgress}
              handleChange={this.handleChange}
              hasChildren={column.hasChildren}
              selectHintOnEnter={false}
              type={'planTypes'}
              dataTestId="plan-type-multiselect"/>
          </Col>
        );
      } else if (column.filter === 'indication') {
        filterRowElements.push(
          <Col key="indication" sm={column.gridWidth} className={`col-sm-offset-${column.offset}`}>
            <MultiSelect
              label={column.label}
              placeholder={column.placeholder}
              options={orderData(indications, 'id', column.orderByIds || [])}
              selected={selectedIndications}
              isFetching={inProgress}
              handleChange={this.handleChange}
              selectHintOnEnter={false}
              type={'indications'}/>
          </Col>
        );
      } else if (column.filter === 'product') {
        filterRowElements.push(
          <Col key="product" sm={column.gridWidth} className={`col-sm-offset-${column.offset}`}>
            <MultiSelect
              label={column.label}
              placeholder={column.placeholder}
              isFetching={inProgress}
              options={sortProducts(products, settings.drugId)}
              handleChange={this.handleChange}
              selected={selectedProducts}
              type={'products'}
            />
          </Col>
        );
      } else if (column.filter === 'pbm') {
        filterRowElements.push(
          <Col key="pbm" sm={column.gridWidth} className={`col-sm-offset-${column.offset}`}>
            <MultiSelect
              label={column.label}
              placeholder={column.placeholder}
              isFetching={inProgress}
              options={pbms}
              handleChange={this.handleChange}
              selected={selectedPbms}
              type={'pbms'}
            />
          </Col>
        );
      }
    });
    filterInputs.push(
      <Row key="filterInputs">
        {filterRowElements}
      </Row>
    );

    const searchButtonStyle = css(styleSheet.modalSuccess, styleSheet.searchButton);
    const isSearchButtonDisabled = inProgress || (Array.isArray(settings.drugId) && selectedProducts.length === 0);

    const getCellClass = (cell) => {
      const {original: rowData} = cell;
      // If rowData is verballyConfirmed, highlight it.
      if (rowData.verballyConfirmed) {
        return css(this.props.styleSheet.highlightRow)
      }

      // If the rowData meets the highlightRowCriteria, highlight it.
      let highlightClass = null;
      if (this.props.settings.table.highlightRowCriteria) {
        for (const rowCriteria of this.props.settings.table.highlightRowCriteria) {
          if (validateObjectProperties(rowData, rowCriteria)) {
            highlightClass = css(this.props.styleSheet.highlightRow);
            break;
          }
        }
        return highlightClass;
      }
    }

    return (
      <div data-component={'Coverage'}>
        <Loader isFetching={inProgress} isFullscreen/>

        <ExitModal
          settings={settings}
          styleSheet={styleSheet}
          showExitModal={showExitModal}
          handleHide={this._handleHide}
          handleOpenDocument={this._handleOpenDocument}
        />

        <FeatureModal
          settings={settings}
          styleSheet={styleSheet}
          showFeatureModal={showFeatureModal}
          handleHide={this._handleHide}
        />

        <DisclaimerModal
          settings={settings}
          styleSheet={styleSheet}
          showDisclaimerModal={showDisclaimerModal}
          handleHide={this._handleHide}
        />

        <CoverageSummaryModal
          settings={settings}
          styleSheet={styleSheet}
          showSummaryModal={showSummaryModal}
          handleHide={this._handleHide}
          handleDocumentClick={this._handleDocumentClick}
          rowData={coverageSummaryHashMap[coverageSummaryClickedId]}
        />

        <ContactInstructionsModal
          settings={settings}
          styleSheet={styleSheet}
          showContactInstructionsModal={showContactInstructionsModal}
          handleHide={this._handleHide}
          rowData={contactInstructionsHashMap[contactInstructionsClickedId]}
        />

        <Grid>
          <Row>
            { Boolean(settings.banner.enabled) &&
            <Col xs={12} className={css(styleSheet.banner)}>
              { Boolean(settings.banner.content.html) &&
                <div dangerouslySetInnerHTML={{__html: settings.banner.content.html}} />
              }
            </Col>
            }
          </Row>
          <Row>
            {
              settings.content.searchPreface &&
              <div className={`searchPreface ${css(styleSheet.searchPreface)}`}>
                <ReactMarkdown escapeHtml={false} source={settings.content.searchPreface}/>
              </div>
            }
            {
              showInstruction &&
              <ReactMarkdown className={`instruction ${css(styleSheet.initialSearchInstruction)}`} escapeHtml={false} source={settings.content.initialSearchInstruction}/>
            }
            <ErrorAlert error={getErrorField('global', 'global', error)} alertVisible={showErrorAlert} handleDismissAlert={this._setAlert.bind(this, ERROR_ALERT, false)}/>
          </Row>
          {!settings.searchCoverageFunctionality.disabled &&
            <React.Fragment>
              {filterInputs}
              {!results && settings.content.underFiltersText &&
                <div>
                  <Row>
                    <Col>
                      <div className={css(styleSheet.underFiltersText)}>
                        <ReactMarkdown escapeHtml={false} source={settings.content.underFiltersText.markdown} />
                      </div>
                    </Col>
                  </Row>
                </div>
              }
              <Row className={'text-center'}>
                <Button
                  type={'submit'}
                  className={ isSearchButtonDisabled ? `${searchButtonStyle} disabled` : searchButtonStyle }
                  disabled={ isSearchButtonDisabled }
                  onClick={ this._filterCoverage }
                >
                  Search
                </Button>
              </Row>
            </React.Fragment>
          }
          {
            settings.usRegionalMap &&
            <Row>
              <Col>
                <USMap
                  handleStateClick={this._handleUSMapClick}
                  selectedStates={selectedStates}
                />
              </Col>
            </Row>
          }

          {showInstruction &&
            <Row>
              <ReactMarkdown escapeHtml={false} source={settings.content.initialSupplementalInstruction.markdown} />
            </Row>
          }
          {results &&
            <Row className={css(styleSheet.results)} id='results'>
              {(!inProgress && tableRows.length === 0 && showNoRowsAlert) &&
                <Row>
                  <Alert bsStyle={'warning'} onDismiss={this._setAlert.bind(this, NO_ROW_ALERT, false)}>{settings.content.tableErrorNoResult}</Alert>
                </Row>
              }
              {(settings.stateCoverageProfiles.enabled && stateCoverageProfiles.length) &&
                <Row>
                  <StateCoverageProfileDocumentDownload
                    settings={settings}
                    styleSheet={styleSheet}
                    stateCoverageProfiles={stateCoverageProfiles}
                  />
                </Row>
              }
              {tableRows.length > 0 &&
                <div>
                  <Row>
                    <div className={css(styleSheet.footNote)}>
                      <ReactMarkdown escapeHtml={false} source={settings.content.tableDisclaimerShort.markdown} />
                    </div>
                  </Row>
                  <Row>
                    <div className={css(styleSheet.dataTable)}>
                      <TabularDataBasic
                        data={tableRows}
                        columns={tableColumns}
                        getCellClass={getCellClass}
                        customFooter={tableFooter}
                      />
                    </div>
                  </Row>
                </div>
              }
              {settings.content.underResultsText &&
                <div>
                  <Row>
                    <Col>
                      <div className={css(styleSheet.underResultsText)}>
                        <ReactMarkdown escapeHtml={false} source={settings.content.underResultsText.markdown} />
                      </div>
                    </Col>
                  </Row>
                </div>
              }
            </Row>
          }
          <Isi settings={settings.isi} styleSheet={styleSheet}/>
          {settings.content.bottomSection &&
            <Row><div className={css(styleSheet.bottomSection)}>
              <ReactMarkdown escapeHtml={false} source={settings.content.bottomSection.markdown} />
            </div></Row>
          }
        </Grid>
      </div>
    );
  }
}

Coverage.propTypes = {
  dispatchGetStatePayerCoverageList: PropTypes.func.isRequired,
  dispatchGetStateCoverageProfiles: PropTypes.func.isRequired,
  dispatchSetStateCoverageShowAlert: PropTypes.func.isRequired,
  coveragePositions: PropTypes.array.isRequired,
  stateCoverageProfiles: PropTypes.array.isRequired,
  lastRefreshedDate: PropTypes.string.isRequired,
  usStates: PropTypes.array,
  payers: PropTypes.array,
  planTypes: PropTypes.array,
  settings: PropTypes.object.isRequired,
  styleSheet: PropTypes.object.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
  ]),
  inProgress: PropTypes.bool,
  showErrorAlert: PropTypes.bool.isRequired,
  showNoRowsAlert: PropTypes.bool.isRequired,
};

/**
 * Generates the payer list from the payers found in all coverage positions.
 *
 * @param  {Object} coverage coverage object from react state.
 * @param  {Object} settings settings object from react state.
 *
 * @return {Array} payers
 */
export function restrictPayers(coverage, settings) {
  let payers = coverage.get('payers').toJS();

  if (
    typeof settings.restrictToCoveragePositionPayers !== 'undefined'
    && settings.restrictToCoveragePositionPayers === true
  ) {
    // Get all unique payers found in the coverage positions.
    let hash = {};
    for (const row of coverage.get('coveragePositions').toJS()) {
      hash[row.payer] = row.payerid;
    }

    payers = [];
    for (const payer in hash) {
      payers.push({id: hash[payer], label: payer});
    }
  }

  return payers;
}

export function extractPbms(coveragePositions) {
  let hash = {};
  for (const row of coveragePositions) {
    hash[row.pbm] = row.pbmid;
  }

  const pbms = Object.entries(hash)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .map(([key, value]) => ({label: key, id: value}));
  return pbms;
}

const mapStateToProps = function (state, ownProps) {
  const {
    coverage,
  } = state;

  return {
    stateCoverageProfiles: coverage.get('stateCoverageProfiles').toJS(),
    coveragePositions: coverage.get('coveragePositions').toJS(),
    usStates: coverage.get('usStates').toJS(),
    products: coverage.get('products').toJS(),
    payers: restrictPayers(coverage, getSettings(state)),
    indications: coverage.get('indications').toJS(),
    pbms: extractPbms(coverage.get('coveragePositions').toJS()),
    planTypes: coverage.get('planTypes').toJS(),
    error: getError(state),
    lastRefreshedDate: getLastRefreshedDate(state),
    inProgress: getInProgress(state),
    settings: getSettings(state),
    showErrorAlert: getShowErrorAlert(state),
    showNoRowsAlert: getShowNoRowsAlert(state),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    dispatchGetStatePayerCoverageList: (...args) => {
      dispatch(getStatePayerCoverageList(...args));
    },
    dispatchGetStateCoverageProfiles: (...args) => {
      dispatch(getStateCoverageProfiles(...args));
    },
    dispatchSetStateCoverageShowAlert: (...args) => {
      dispatch(setStateCoverageShowAlert(...args));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Coverage);
